import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ChallengeProvider } from "./context/ChallengeContext";
import { NotificationCountProvider } from "./context/NotificationCountContext";
import { installRateLimitHandler } from "./helper/rateLimitHandler";

installRateLimitHandler();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <NotificationCountProvider>
        <ChallengeProvider>
          <App />
        </ChallengeProvider>
      </NotificationCountProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.documentElement.classList.remove("preload");
  });
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
